import { createSelector } from 'reselect';
import { parseISO } from 'date-fns';

import { reportsSchedules as reportsSchedulesEntity } from 'store/saga/entities/bound';

// entity fields

export const selectReportsSchedulesIsLoading = state =>
  !reportsSchedulesEntity.loaded(state) || reportsSchedulesEntity.loading(state);

const selectReportsSchedulesIsLoaded = state => reportsSchedulesEntity.loaded(state);
const selectReportsSchedulesData = state => reportsSchedulesEntity.data(state);
export const selectReportsSchedules = createSelector(
  selectReportsSchedulesIsLoaded,
  selectReportsSchedulesData,
  (isLoaded, reportsSchedulesData) =>
    isLoaded
      ? {
          ...reportsSchedulesData,
          report: reportsSchedulesData.report.map(schedule => ({
            ...schedule,
            dateTime: parseISO(`${schedule.date} ${schedule.startTime}`),
          })),
        }
      : {}
);

// reducer fields

export const selectReportsSchedulesControls = state => state.reportsSchedules;
